


























  import { Component, Vue, Provide } from 'vue-property-decorator';
  import { csvtype } from '../../../src';

  @Component
  export default class VsInput extends Vue {
      @Provide() private kanjterm = '行く';
      @Provide() private kanaterm = 'いく';
      @Provide() private posid = 33;

      get posData() {
          const ct = this.$conjtables;
          // tslint:disable-next-line:no-string-literal
          const poskws = [...new Set(Object.values(ct['conjo'])
              // get posid
              .map((v) => v[0]))];

          const availpos = poskws
              // tslint:disable-next-line:no-string-literal
              .map((posid) => ct['kwpos'][posid as number])
              .sortBy((x) => x[1]);

          return availpos;
      }

      private search() {
          // enables use of the @search directive
          // to bind the onSearch function in App.vue
          this.$emit('search', {
              kanj: this.kanjterm,
              kana: this.kanaterm,
              pos: this.posid,
          });
      }
}
